import { useFeatureGate } from '@statsig/react-bindings';
import { useAuthUser } from './useAuth';

/**
 * Returns true if the user management feature is enabled.
 * Controlled by the Statsig `user_management` feature gate (targets clientId).
 * Superusers always have access regardless of the gate.
 */
export const useUserManagementEnabled = (): boolean => {
  const { value: featureEnabled } = useFeatureGate('user_management');
  const { isSuperUser } = useAuthUser();
  return featureEnabled || isSuperUser;
};
